import React from "react";
import {
  Image,
  ImageFit,
  IImageProps,
  Label,
  ActionButton,
  TooltipHost,
} from "@fluentui/react";
import classes from "./ExpertCard.module.scss";
import "../../../../bosch-react/icon.scss";
import { IEvidenceDetail, IEvidenceResponse, IPerson, getEvidences } from "../../services";
import Helper from "../../../../core/libraries/Helper";


interface IExpertCardProps {
  expert: IPerson;
  evidenceQuery: string;
  onShowEvidence: any;
}

interface IState {
  isLoading: boolean,
  evidenceItems: IEvidenceResponse | null,

}

export default class ExpertCard extends React.Component<IExpertCardProps, IState> {
  onActionClick = (
    action: string,
    ev: React.SyntheticEvent<HTMLElement>
  ): void => {
    console.log(`You clicked the ${action} action`);
    ev.stopPropagation();
    ev.preventDefault();
  };

  imageProps: IImageProps = {
    imageFit: ImageFit.centerCover,
    shouldFadeIn: true,
    style: {
      borderRadius: "50%",
    },
    loading: "lazy",
  };

  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: false,
      evidenceItems: null
    };
  }


  retrieveEvidenceUrl = async () => {
    const { feid } = this.props.expert;
    const query = this.props.evidenceQuery;
    const url = `${process.env.REACT_APP_EXPERT_API_BASE_URL}/${feid}/evidence?q=${query}&mode=full`;
  
    const cacheKey = `evidenceCache:${url}`;
  
    // Try to get data from sessionStorage
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) {
      const cachedData = JSON.parse(cached);
      this.setState({
        evidenceItems: cachedData,
        isLoading: false
      }, () => {
        this.props.onShowEvidence(this.state.evidenceItems);
      });
      return;
    }
  
    // If not in cache, fetch from API
    this.setState({ isLoading: true });
    const evidenceResponse = await getEvidences(url);
  
    this.setState({
      evidenceItems: evidenceResponse || null,
      isLoading: false
    }, () => {
      // Save to sessionStorage
      if (this.state.evidenceItems) {
        sessionStorage.setItem(cacheKey, JSON.stringify(this.state.evidenceItems));
      }
      this.props.onShowEvidence(this.state.evidenceItems);
    });
  }
  


  render() {
    const expert = this.props.expert;
    const calloutProps = { gapSpace: 0 };
    return (
      <div className=" ms-Grid">
        <div className="ms-Grid-row">
          <div
            className={
              `${classes.imageContainer} ms-Grid-col ms-xxl4 ms-xl4 ms-lg12`
            }
          >
            <Image
              {...this.imageProps}
              src={expert.picture}
              alt="Example with no image fit value and height or width is specified."
            />
          </div>
          <div className="ms-Grid-col ms-xxl8 ms-xl8 ms-lg12">
            <div className="ms-Grid">
              <div className="ms-Grid-row">
                <div className={`ms-Grid-col ms-sm10`}>
                  <a
                    style={{ textDecoration: "none" }}
                    target="_blank"
                    href={`https://connect.bosch.com/profiles/html/profileView.do?email=${expert.email}#&tabinst=Updates`} rel="noreferrer"
                  >
                    <h2 className={classes.expertName}>
                      {expert.display_name}
                    </h2>
                  </a>
                </div>
                <div className={classes.beoText + " ms-Grid-col ms-sm2"}>
                  <TooltipHost
                    content="Bosch Experts Organization"
                    // Give the user more time to interact with the tooltip before it closes
                    closeDelay={1000}
                    id={"beo"}
                    calloutProps={calloutProps}
                  >
                    <span>BEO</span>
                  </TooltipHost>
                </div>
              </div>
            </div>
            <Label className={classes.isSecondary}>{expert.job_title}</Label>
          </div>
        </div>
        <div className={classes.actionsContainer + " ms-Grid-row"}>
          <div className="ms-Grid-col ms-xl3 ms-lg6">
            <a href={`mailto:${expert.email}`}>
              <ActionButton allowDisabledFocus>
                <i className="ms-Icon ms-Icon--Mail" aria-hidden="true"></i>
              </ActionButton>
            </a>
          </div>
          <div className="ms-Grid-col ms-xl3 ms-lg6">
            <a href={`sip:${expert.email}`}>
              <ActionButton allowDisabledFocus>
                <i
                  className="ms-Icon ms-Icon--TeamsLogo"
                  aria-hidden="true"
                ></i>
              </ActionButton>
            </a>
          </div>
          <div className="ms-Grid-col ms-xl3 ms-lg6">
            <ActionButton
              allowDisabledFocus
              onClick={(event) =>
                this.retrieveEvidenceUrl()
              }
              disabled={this.state.isLoading}
            >
              <i className="ms-Icon ms-Icon--Lightbulb" aria-hidden="true"></i>
            </ActionButton>
          </div>
          <div className="ms-Grid-col ms-xl3 ms-lg6">
            <a href={`tel:${expert.phone && expert.phone.primary}`}>
              <ActionButton allowDisabledFocus>
                <i className="ms-Icon ms-Icon--Phone" aria-hidden="true"></i>
              </ActionButton>
            </a>
          </div>
        </div>
        <hr className={classes.seperator}></hr>
      </div>
    );
  }
}
